import {Injectable} from '@angular/core';
import { HTTPService } from './http.service';
@Injectable()
export class HostSiteService {

    constructor(private http:HTTPService) {

    }

    getHostSites() :Promise<any[]>{
        return this.http.get("/hostsites/").then((result) => {
            let data = result.json() as any;
            if (data.length) {
                return data.map(i => {
                    return {
                        "id": i.id,
                        "name": i.name
                    };
                });
            }
            return [];
        });
        // return [{id: 1, name: "Discover and Change"}, {id: 2, name:"Addo Recovery"}, {id: 3, name:"Addo Recovery Network"}, {id: 4, name:"APSATS"}];
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/host-site.service.ts